
<template>
    <div class="app-nav-wrap">

        <el-menu :default-active="this.$route.path" :router="true" unique-opened
                 :collapse="isCollapse" :class="[isCollapse?'menu_hidden':'menu_open']">


            <template v-for="item in listMenuLeft">

                <el-menu-item v-if="!item.listMenuDTO || item.listMenuDTO.length==0" :key="item.url" :index="item.url">
                    <i :class="item.icon"></i>
                    <span slot="title">{{replaceStr(item.name)}}</span>
                </el-menu-item>


                <el-submenu v-else-if="item.listMenuDTO || item.listMenuDTO.length>0" :index="item.url" :key="item.url">
                    <template slot="title">
                        <i :class="item.icon"></i>
                        <span slot="title">{{replaceStr(item.name)}}</span>
                    </template>



                    <!-- just for 2 level-->
                    <template v-for="sub2 in item.listMenuDTO">
                        <!-- 222222-->
                        <el-menu-item v-if="!sub2.listMenuDTO || sub2.listMenuDTO.length==0" :index="sub2.url" :key="sub2.url" style="padding-left: 20px;">
                          <span class="dot"></span>
                          <span slot="title" >{{replaceStr(sub2.name)}}</span>
                        </el-menu-item>
                    </template>




                    <!-- just for 3 level-->
<!--                    <el-menu-item-group>-->
<!--                        <template v-for="sub2 in item.children">-->

<!--                            &lt;!&ndash; 222222&ndash;&gt;-->
<!--                            <el-menu-item v-if="!sub2.children || sub2.children.length==0" :index="sub2.route" :key="sub2.route">-->
<!--                                <i class="el-icon-menu"></i>-->
<!--                                <span slot="title">{{sub2.name}}</span>-->
<!--                            </el-menu-item>-->

<!--                            <el-submenu v-else-if="sub2.children || sub2.children.length>0" :key="sub2.route" :index="sub2.route">-->
<!--                                <template slot="title">-->
<!--                                    <i class="el-icon-menu"></i>-->
<!--                                    <span slot="title">{{sub2.name}}</span>-->
<!--                                </template>-->

<!--                                <el-menu-item-group>-->
<!--                                    <template v-for="sub3 in sub2.children">-->
<!--                                        &lt;!&ndash; 333333&ndash;&gt;-->
<!--                                        <el-menu-item :index="sub3.route" :key="sub3.route">-->
<!--                                            <i class="el-icon-menu"></i>-->
<!--                                            <span slot="title">{{sub3.name}}</span>-->
<!--                                        </el-menu-item>-->
<!--                                    </template>-->
<!--                                </el-menu-item-group>-->
<!--                            </el-submenu>-->

<!--                        </template>-->
<!--                    </el-menu-item-group>-->



                </el-submenu>


            </template>


        </el-menu>


    </div>
</template>

<script>

import {replaceStr} from '@/utils/auth'

    export default {
        props: ["isCollapse"],
        data () {
            return{
                listMenuLeft:this.$store.state.listMenuLeft,
            }
        },
        watch: {

            //监听局部变量
            // listMenuLeft(newValue, oldValue) {
            //     console.log(newValue+"--"+oldValue)
            // },

            //监听全局变量
            '$store.state.listMenuLeft' : function(val){
                this.listMenuLeft = val;
            },
        },
        methods:{

          replaceStr(name){
            return replaceStr(name);
          },


        }

    }
</script>


<style>

</style>

<style lang="scss" scoped>

</style>
